/* istanbul ignore file */
// TODO [LEARN-15811]: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CurriculumRouteContentGetter as RouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import { navigationEvent } from 'layers/navigation/store/operations'
import withApiError from 'layers/errorHandling/apiError'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import {
  AI_HS_PAGE_USAGE_KEY,
  sendApplicationInsightsEvent,
} from 'utils/sendAnalyticsDataHelpers'
import { isTier2PreviewMode } from 'utils/urlHelpers'
import {
  resolveRouteServiceApp,
  isHighSchoolUrl,
  isK5Url,
  isMiddleSchoolUrl,
} from 'utils/productHelpers'
import { isPreviewMode } from 'utils/highschoolHelpers'
import { selectors as lmsSelectors } from 'store/lmsManager'
import { selectors as contextSelectors } from 'auth/stores/userContext'

import Component from './component'

const IndividualResourceContainer = props => {
  const {
    routeContent,
    userSegmentationInfo,
    navigationEvent,
    productTabTitle,
    instructorData,
    userContext,
    match,
  } = props || {}
  const { content = {}, loading } = routeContent
  const queryType = routeContent?.route?.queryType
  const learningExperience =
    (queryType && content?.[queryType]) || content?.learningExperience || null

  const readyToLoad = !loading && !!learningExperience

  useEffect(() => {
    sendApplicationInsightsEvent(AI_HS_PAGE_USAGE_KEY, userSegmentationInfo)
  }, [content])

  const isTier2Preview = isTier2PreviewMode()
  const isHsPreview = isPreviewMode() && isHighSchoolUrl()
  // isPreview is true if either preview mode is active
  const isPreview = isTier2Preview || isHsPreview

  return readyToLoad ? (
    <Component
      entry={learningExperience}
      gradeInstructorData={instructorData}
      isHsPreview={isHsPreview}
      isPreview={isPreview}
      match={match}
      navigationEvent={navigationEvent}
      productTabTitle={productTabTitle}
      routeContent={routeContent}
      userContext={userContext}
    />
  ) : null
}

IndividualResourceContainer.propTypes = {
  instructorData: PropTypes.object,
  routeContent: PropTypes.shape({
    content: PropTypes.shape({
      learningExperience: PropTypes.object,
    }),
    loading: PropTypes.bool,
  }),
  userContext: PropTypes.object,
  userSegmentationInfo: PropTypes.object,
}

const mapStateToProps = (state, _) => {
  // Determine which instructor data to use based on the current URL
  let instructorData = null
  if (isHighSchoolUrl()) {
    instructorData = lmsSelectors.selectHsInstructorData(state)
  } else if (isMiddleSchoolUrl()) {
    instructorData = lmsSelectors.selectMiddleSchoolInstructorData(state)
  } else if (isK5Url()) {
    instructorData = lmsSelectors.selectk5InstructorData(state)
  }

  return {
    userSegmentationInfo: userSegmentationBuilder(state),
    productTabTitle: state.productManager?.productMap?.name || '',
    instructorData,
    userContext: contextSelectors.selectProgramContext(state),
  }
}

const mapDispatchToProps = {
  navigationEvent,
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const HydratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndividualResourceContainer)

export default withSiteContext(
  RouteContentGetter(withApiError(HydratedComponent), options),
)
